<template>
    <div>
        <div class="bg-primary-color pb-32">
            <admin-nav v-if="$page.props.auth.user.role === $SUPER_ADMIN_ROLE || $page.props.auth.user.role === $ADMIN_ROLE"></admin-nav>
            <gin-nav v-if="$page.props.auth.user.role === $GIN_ROLE"></gin-nav>
            <customer-nav v-if="$page.props.auth.user.role === $CUSTOMER_ROLE"></customer-nav>
            <header class="py-10">
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 class="text-3xl font-bold text-primary-color">
                        {{ title }}
                    </h1>
                </div>
            </header>
        </div>

        <main class="-mt-32">
            <div class="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
                <div class="bg-white rounded-lg shadow px-5 py-6 sm:px-6" style="min-height:80vh;">
                    <flash-messages />
                    <slot />
                </div>
            </div>
        </main>
    </div>

</template>

<script>
import FlashMessages from '@/Shared/FlashMessages'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import AdminNav from "@/Components/Navigation/AdminNav";
import GinNav from "@/Components/Navigation/GinNav";
import CustomerNav from "@/Components/Navigation/CustomerNav";

export default {
    props: {
        title: String,
    },
    components: {
        CustomerNav,
        GinNav,
        AdminNav,
        FlashMessages,
        Icon,
        Logo,
    },
    data() {
        return {
            showUserMenu: false,
            showMobileMenu: false,
        }
    },
    methods: {
        url() {
            return location.pathname.substr(1)
        },
    },
    watch: {
        title: {
            immediate: true,
            handler(title) {
                document.title = title
            },
        },
    },
}
</script>
